import React from 'react';

import {twx} from '@/utils/tailwindUtils';

import {AppButton} from '../../../components/Button';
import appRouterService from '../../../services/route/appRouterService';

//TODO: VR uncomment if need to save error codes
const NotNowButtonAD = ({
    screenName,
    isPrimary,
    className,
    inferenceCode,
    inferenceCode_L1,
    holderInferenceCode,
    holderInferenceCode_L1,
    isHolder,
    isQuestionnaireThirdStep,
    children,
    'aria-label': ariaLabel,
}) => {
    const onNotNowButtonClick = () => {
        //TODO: VR uncomment if need to save error codes
        /*if (inferenceCode && holderInferenceCode) {
            storageService.setFinishAdvancedDiagnosticsDataToLocalStorage({
                inferenceCode,
                inferenceCode_L1: inferenceCode_L1 || inferenceCode,
                screenName,
            });
            storageService.setFinishAdvancedDiagnosticsDataToLocalStorage({
                inferenceCode: holderInferenceCode,
                inferenceCode_L1: holderInferenceCode_L1 || holderInferenceCode,
                screenName,
                isHolder: true,
            });
        } else {
            storageService.setFinishAdvancedDiagnosticsDataToLocalStorage({
                inferenceCode: inferenceCode || holderInferenceCode,
                inferenceCode_L1: inferenceCode_L1 || holderInferenceCode_L1 || inferenceCode || holderInferenceCode,
                screenName: advanceDiagnosticScreenTypes[screenName],
                isQuestionnaireThirdStep,
                isHolder,
            });
        }*/

        appRouterService.forwardToDevicesPage();
    };

    return (
        <AppButton
            secondary={!isPrimary}
            light={!isPrimary}
            primary={isPrimary}
            onClick={onNotNowButtonClick}
            className={twx('mt-0 min-w-[312px]', className)}
            aria-label={ariaLabel}
        >
            {children}
        </AppButton>
    );
};

export default NotNowButtonAD;
